// extracted by mini-css-extract-plugin
module.exports = {"slide-left":"styles_slide-left__SZYvq"};